import { makeStyles } from '@material-ui/core';

export const usePlanStructureSectionStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%',
  },
  description: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.32px',
  },
  selector: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '12px 0 0',
    boxSizing: 'border-box',
  },
  widget: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  cards: {
    display: 'flex',
    gap: '24px',
    width: '100%',
    alignItems: 'stretch',
  },
}));
